// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","InstagramEmbed":"bai_a","InstagramEmbed__mask":"bai_b bha_bi bha_bo bha_vt"};